import StackTrace from 'stacktrace-js'
import Bottleneck from 'bottleneck/es5'
const limiter = new Bottleneck({ maxConcurrent: 3, highWater: 10 })
const STAGE = process.env.STAGE
const settings = {
  dev: {
    url: 'https://p4znz771ud.execute-api.eu-central-1.amazonaws.com/test/log',
    key: 'U9sQWV5jS48zGIKPrieera9nuFOjYGjU2HqOlPVT',
  },
  test: {
    url: 'https://p4znz771ud.execute-api.eu-central-1.amazonaws.com/test/log',
    key: 'U9sQWV5jS48zGIKPrieera9nuFOjYGjU2HqOlPVT',
  },
  prod: {
    url: 'https://t3y0c2s7y8.execute-api.eu-central-1.amazonaws.com/prod/log',
    key: 'QUpcGtb8wQ2mRWRjcwJZFxcGimzqDt54479A5z98',
  },
}

export const sendEvent = limiter.wrap(async function(payload) {
  return fetch(settings[STAGE].url, {
    mode: 'cors',
    cache: 'no-cache',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': settings[STAGE].key,
    },
    body: JSON.stringify(payload),
  })
})

export const handleError = limiter.wrap(async error => {
  const msg = error.message
  const STAGE = process.env.STAGE

  if (STAGE === 'dev') {
    console.error(error)
    return
  }

  try {
    const frames = await StackTrace.fromError(error)
    let fileName = ''
    let functionName = ''

    if (frames || frames.length !== 0) {
      fileName = frames[0].fileName
      functionName = frames[0].functionName
    }

    const log = {
      name: 'log',
      payload: {
        screen: {
          availHeight: window.screen.availHeight,
          availLeft: window.screen.availLeft,
          availTop: window.screen.availTop,
          availWidth: window.screen.availWidth,
          colorDepth: window.screen.colorDepth,
          height: window.screen.height,
          pixelDepth: window.screen.pixelDepth,
          width: window.screen.width,
        },
        environment: STAGE,
        application: 'bea',
        msg: msg,
        fileName: fileName,
        functionName: functionName,
        stackTrace: error.stack,
      },
    }
    await sendEvent(log)
  } catch (err) {
    if (process.env.STAGE !== 'prod') {
      console.error(err)
    }
  }
})
